/**
 * Insight feedback service (010): submit helpful/not_relevant feedback.
 * Contract: submitFeedback(userId, insightId, feedbackType) inserts into insight_feedback; RLS enforces user_id.
 */

import { supabase } from '../lib/supabase';

export type FeedbackType = 'helpful' | 'not_relevant';

export interface InsightFeedbackRecord {
  insightId: string;
  feedbackType: FeedbackType;
}

export async function submitFeedback(
  userId: string,
  insightId: string,
  feedbackType: FeedbackType
): Promise<{ error?: Error | null; success: boolean }> {
  const { error } = await (supabase as any).from('insight_feedback').insert({
    user_id: userId,
    insight_id: insightId,
    feedback_type: feedbackType,
  });

  if (error) {
    return { error, success: false };
  }

  return { success: true };
}

export async function getFeedbackForInsights(
  userId: string,
  insightIds: string[]
): Promise<Map<string, FeedbackType>> {
  const map = new Map<string, FeedbackType>();
  if (insightIds.length === 0) return map;

  const { data, error } = await (supabase as any)
    .from('insight_feedback')
    .select('insight_id, feedback_type')
    .eq('user_id', userId)
    .in('insight_id', insightIds)
    .order('created_at', { ascending: false });

  if (error || !data) return map;

  for (const row of data as { insight_id: string; feedback_type: string }[]) {
    if (map.has(row.insight_id)) continue;
    if (row.feedback_type === 'helpful' || row.feedback_type === 'not_relevant') {
      map.set(row.insight_id, row.feedback_type);
    }
  }

  return map;
}
